import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=405e2946&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=405e2946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e2946",
  null
  
)

export default component.exports